// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var scaling = 16 / 17;

function t(lightOpt, darkOpt, errorColorOpt, param) {
  var light = lightOpt !== undefined ? lightOpt : ({
        borderColor: Theme__Color$PrezzeeRibbon.gray400,
        hoverBorderColor: Theme__Color$PrezzeeRibbon.gray600,
        focusBorderColor: Theme__Color$PrezzeeRibbon.blue400,
        color: Theme__Color$PrezzeeRibbon.gray800,
        placeholderColor: Theme__Color$PrezzeeRibbon.gray600
      });
  var dark = darkOpt !== undefined ? darkOpt : ({
        borderColor: Theme__Color$PrezzeeRibbon.white,
        hoverBorderColor: Theme__Color$PrezzeeRibbon.white,
        focusBorderColor: Theme__Color$PrezzeeRibbon.white,
        color: Theme__Color$PrezzeeRibbon.white,
        placeholderColor: Theme__Color$PrezzeeRibbon.white
      });
  var errorColor = errorColorOpt !== undefined ? errorColorOpt : Theme__Color$PrezzeeRibbon.red400;
  return {
          light: light,
          dark: dark,
          errorColor: errorColor
        };
}

var vertP = 12;

var horizontalP = 16;

var legendOffset = 5;

var fontS = 17;

export {
  vertP ,
  horizontalP ,
  legendOffset ,
  fontS ,
  scaling ,
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
